var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Opções de Grid","p-read-link":"gridOption.read.one","p-create-link":"gridOption.create","p-name":"gridOptions"}})}
var staticRenderFns = []

export { render, staticRenderFns }